<template>
  <div class="container-fluid">
  <div class="row">
    <div class="col-sm-12 col-md-12 col-lg-6">
      <div class="bdy mt-5 ml-5 mr-5 left">
         <button type="button" class="btn btn-outline-primary ml-0 disabled">COMING SOON</button>
         <p class=" mt-3 mb-4 tittle">Health Facility <br> Survey Dashboard</p>

         <div class="text-body  ">
           <p class="text-left msg">This dashboard provides a single transparent view of data from health facilities across the country. By transparently visualizing data and trends, we intend improving the debate and focus on data quality and its use, so as to improve our overall understanding of key trends and progress within the health sector.</p>
         </div>

         <div class="text-body  mt-3">
           <p class="text-left msg2">This resource is currently not available. If you would like to be informed about its development, please leave your contact information below.</p>
         </div>

           <form class="mb-4" v-on:submit.prevent="newInterest()">
            <div class="form-row  mt-4">
              <div class="col-sm-7 pl-1 pr-0 pb-2">
                <input type="email" name="email" v-model="signupFormFields.email" class="form-control ml-0" placeholder="Your e-mail address" required>
              </div>
              <div class="col-sm-5 pl-1">
                <button type="submit" class="btn btn-primary mb-2 pr-4 pl-4">Keep me Updated!</button>
              </div>
            </div>
          </form>
<br>
<br>
             
          <p class="link-text mt-4 mb-4 ml-1"><router-link to="/central_analytics" style="color: #007D53"><i class="fas fa-angle-left" aria-hidden="true"></i>&nbsp;&nbsp;Back to MSDAT</router-link></p>

      </div>
    </div>
     <div class="col-sm-1 "></div>
    <div class="col-lg-5 col-md-12 col-sm-12  bg-white right pr-0 pl-0" id="image" style="height:80vh;background: url(static/img/subdashboards/);">
      <img src="static/img/subdashboards/healthfacility.jpg" class="img-responsive"  alt="Health facility survey image">
    </div>
  </div>
</div>
</template>
      <script>
      import moment from 'moment';
      import axios from "axios";
      import {indDB} from '../../../../main';

        export default {
          data: function () {
                  return{
                    userData:[],
                    syncData:[],
                    online:false,

                      signupFormFields: {
                        email: "",
                        dashboard: 'Health Facility Survey',

                    },
                  }
              },
              async mounted () {
               
              },
              
              methods:{
                
                  newInterest(){
                    this.checkOnline();
                    self = this;
                      let now = moment().format('LLLL');
                      console.log(now);
                      console.log(self.online);

                      const payload = {
                        email: this.signupFormFields.email,
                        dashboard: this.signupFormFields.dashboard,
                        created: now
                      };
                      if (self.online === true) {
                            console.log(payload);
                            axios.post('https://msdatapi.e4eweb.space/api/v1/subDashboardInterest/', JSON.stringify (payload) )
                                .then(function (response) {
                                console.log(response);
                                let res = response.status
                                if (res == 200 || res == 201) {
                                  self.signupFormFields.email = ""
                                  self.alertSuccess()
                                } else {
                                  self.alertFailure()
                                }
                                })
                          } else{
                            this.$swal({
                              icon: 'error',
                              title: 'OOPs!!',
                              text: 'Your seem to be ofline, please reconnect and try again',
                              footer: ''
                            });
                        }
                      
                      },

                    checkOnline(){
                        // var online = window.navigator.onLine;

                        if (window.navigator.onLine === true) {
                            this.online = true
                            console.log(this.online)
                          } else{
                            this.online = false
                            console.log(this.online)
                        }
                    },
                    alertSuccess() {
                      this.$swal({
                          icon: 'success',
                          title: 'Thank you',
                          text: 'You will be the first to know when its out!',
                          footer: ''
                        
                      });
                    },
                    alertFailure() {
                      this.$swal({
                          icon: 'error',
                          title: 'OOPs !!',
                          text: 'There seem to be an error in your entry, please try again later!',
                          footer: ''
                        
                      });
                    },

                  // addUser () {
                  //     let now = moment().format('LLLL');
                  //     console.log(now);
                  //     const interest = {
                  //       email: this.signupFormFields.email,
                  //       dashboard: this.signupFormFields.dashboard,
                  //       created: now,
                  //     };
                  //   this.userData.push(interest);
                  //   this.index = this.userData.length - 1;

                  //   indDB.transaction('rw',indDB.sub_dashboard_interests,() => 
                  //     {
                  //       indDB.sub_dashboard_interests.add(interest);
                  //     });
                  //   this.signupFormFields.email ="";
                  //   this.alertDisplay();
                  
                  // var ifConnected = window.navigator.onLine;

                  //     if (ifConnected) {

                  //         try {

                  //               indDB.sub_dashboard_interests.each(sub_dashboard_interest => {this.syncData.push(sub_dashboard_interest);});
                      
                  //         } catch (e) {
                  //           // console.error(e)
                  //         }
                  //         // console.log(this.syncData);
                  //        this.synchDatabases();
                  //     }
                  // },

                      // synchDatabases(){
                      //       let datas = this.syncData
                      //       console.log(datas)
                      //       datas.forEach(data => {
                      //         let payload = data

                                    

                      //                                     axios.post('http://172.93.50.34:9000/api/v1/subDashboardInterest', payload)
                      //                                       .then(function (response) {
                      //                                         console.log(response.status);

                      //                                         let res = response.status
                            
                      //                                               if (res == 201) {
                      //                                                   console.log("-")
                      //                                                   console.log("--")
                      //                                                   console.log("---")
                      //                                                   console.log("----")
                      //                                                   console.log("User Added")
                      //                                                   console.log("----")
                      //                                                   console.log("---")
                      //                                                   console.log("--")
                      //                                                   console.log("-")
                                                        
                                                                  
                      //                                                   console.log("-")
                      //                                                   console.log("--")
                      //                                                   console.log("---")
                      //                                                   console.log("----")
                      //                                                   console.log("Removing Record from Ofline Database Now ...")
                      //                                                   console.log("----")
                      //                                                   console.log("---")
                      //                                                   console.log("--")
                      //                                                   console.log("-")
                                                                  

                      //                                               indDB.sub_dashboard_interests.clear();
                      //                                                   console.log("-")
                      //                                                   console.log("--")
                      //                                                   console.log("---")
                      //                                                   console.log("----")
                      //                                                   console.log("Record removed from Ofline Database ")
                      //                                                   console.log("----")
                      //                                                   console.log("---")
                      //                                                   console.log("--")
                      //                                                   console.log("-")
                                                              
                                                                  
                      //                                             }
                      //                                       })
                      //                                       .catch(function (error) {
                      //                                         console.log(error);
                      //                                       });
                      //                      this.syncData.splice(0, this.syncData.length);                    
                                    
                      //       });
                      // }
                },
        }
        
      </script>

<style lang="" scoped>
  .btn-outline-primary{
    border: 2px solid #FF8F0F;
    color:  #FF8F0F !important;
    font-weight: bold;
    background-color: white !important;
    opacity: 1;
    font-size: 11px;
    font-family: 'Muli', sans-serif;
    cursor: default;
    height: 30px;
  }
  .btn-outline-primary:focus {
      outline: none;
    }
  .btn-primary{
    color:  #fff !important;
    font-weight: bold;
    border:2px solid #FF8F0F !important;
    background-color: #FF8F0F !important;
    opacity: 1;
    font-size: 13px;
    font-family: 'Muli', sans-serif;
    text-transform: none!important;
    margin: 0px;
    height: 41px;
    font-size: 12px !important;

  }
  

  .btn-primary:hover{
    color:  #FF8F0F !important;
    background-color: #fff !important;
  }
   .tittle{
    color:  #232323 !important;
    font-weight: bold;
    background-color: white !important;
    opacity: 1;
    line-height: 55px;
    font-size: 43px;
    font-family: 'Muli', sans-serif;
    
  }
  .text-body{
    padding: 4px;
    font-family: 'Muli', sans-serif;
  }
  input{
    font-size: 14px !important;
    font-family: 'Muli', sans-serif;
    height: 42px;
  }

  .msg{
    font-weight:normal;
    color: #232323;
    font-family: 'Muli', sans-serif;
    font-size: 16px;
  }
  .msg2{
    font-weight:normal;
    color: #5A5A5A;
    font-family: 'Muli', sans-serif;
    font-size: 14px;
  }
  .link-text{
    color: #007D53 !important;
    font-weight: bold;
    font-family: 'Muli', sans-serif;
    font-size: 11px;
  }
  .link-text a:hover{
   text-decoration: none !important;
  }
  
  /* Tablet ----------- */
@media only screen and (max-width : 1000px) {
    #image {
        display: none;
    }
}

/* Smartphones (portrait) ----------- */
@media only screen and (max-width : 320px) {
     #image {
        display: none;
    }
}
 
  
</style>


// WEBPACK FOOTER //
// healthFacilitySurvey.vue?e5d160a0